import { jsx as s } from "react/jsx-runtime";
import { forwardRef as a } from "react";
import { faClose as f } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon as d } from "@fortawesome/react-fontawesome";
import * as o from "@radix-ui/react-popover";
import { Button as P } from "../button/Button.js";
import { twMerge as i } from "tailwind-merge";
const l = a(
  ({ className: r, children: e, ...t }, n) => /* @__PURE__ */ s(
    o.Content,
    {
      ref: n,
      className: i("z-pentOutermost shadow-popover rounded-xl bg-white", r),
      ...t,
      children: e
    }
  )
);
l.displayName = o.Content.displayName;
const m = a(
  ({ className: r, ...e }, t) => /* @__PURE__ */ s(
    o.Arrow,
    {
      ref: t,
      className: i("fill-white", r),
      ...e
    }
  )
);
m.displayName = o.Arrow.displayName;
const p = a(
  ({ className: r, children: e, "aria-label": t, ...n }, c) => /* @__PURE__ */ s(
    o.Close,
    {
      ref: c,
      className: i("z-pentOutermost", r),
      asChild: !0,
      ...n,
      children: /* @__PURE__ */ s(P, { variant: "none", "aria-label": t ?? "Close", children: e || /* @__PURE__ */ s(d, { size: "lg", icon: f, className: "text-gray-500" }) })
    }
  )
);
p.displayName = o.Close.displayName;
const v = o.Root, C = o.Portal, g = o.Trigger, w = o.Anchor, R = v, b = C, z = g, T = w, O = l, j = p, B = m;
export {
  T as Anchor,
  B as Arrow,
  j as Close,
  O as Content,
  w as PopoverAnchor,
  m as PopoverArrow,
  p as PopoverClose,
  l as PopoverContent,
  C as PopoverPortal,
  v as PopoverRoot,
  g as PopoverTrigger,
  b as Portal,
  R as Root,
  z as Trigger
};
